import {signInWithGoogle, signInWithFacebook, AuthTokenService} from '@/handler/authService';
import {api, apiWithoutAuth} from '@/plugins/axios'
import {useRouter} from 'vue-router'
import {nextTick, ref} from 'vue'
const isProcessing = ref(false)
const isGoogleUser = ref(null);
const isFacebookUser = ref(null);

isGoogleUser.value = JSON.parse(localStorage.getItem('GoogleAuthUser'));
isFacebookUser.value = JSON.parse(localStorage.getItem('FacebookAuthUser'));

function useSocialLogin(validation, confirmer) {
    const router = useRouter()

    const submitLimiter = () => {
        setTimeout(() => {
            isProcessing.value = false
        }, 3000)
    }

    const signInWithGoogleMethod = async () => {
        try {
            isProcessing.value = true;
            submitLimiter()
            const user = await signInWithGoogle();
            isGoogleUser.value = {displayName: user.displayName, email: user.email, photoURL: user.photoURL};
            localStorage.setItem('GoogleAuthUser', JSON.stringify({displayName: user.displayName, email: user.email, photoURL: user.photoURL}))
            if(user.accessToken) {
                try {
                    const response = await apiWithoutAuth.get(`/user/firebase/get-user-detail/?idToken=${user.accessToken}`);
                    if(!response.data.user_exists){
                        nextTick(() => {
                            router.push({path: `/set-password/${user.accessToken}`, state: response.data})
                        })
                    }else{
                        if(response && (response.data.token.access_token)) {
                            AuthTokenService.setTokens(response.data.token.access_token, response.data.token.refresh_token)
                            if(response.success){
                                router.push({name: 'dashboard'})
                            }
                        }
                    }
                    submitLimiter()
                } catch(error) {
                    console.log('error on sign' , error)
                    validation.storeApiValidation(error.response.data)
                    submitLimiter()
                }
            }
            if(!AuthTokenService.getAccessToken()) {
                router.push('/login')
            }
            // Handle successful sign-in, e.g., update user state or navigate to another page
        } catch(error) {
            console.log('Error signing in:', error.response)
            submitLimiter()
            // Handle sign-in error
        }
    }

    const signInWithFacebookMethod = async () => {
        try {
            isProcessing.value = true;
            submitLimiter()
            const fbuser = await signInWithFacebook();
            isFacebookUser.value = {displayName: fbuser.displayName, email: fbuser.email, photoURL: fbuser.photoURL};
            localStorage.setItem('FacebookAuthUser', JSON.stringify({displayName: fbuser.displayName, email: fbuser.email, photoURL: fbuser.photoURL}))
            if(fbuser.accessToken) {
                try {
                    const response = await apiWithoutAuth.get(`/user/firebase/get-user-detail/?idToken=${fbuser.accessToken}`);
                    // console.log('API Response', response);
                    submitLimiter()
                    if(!response.data.user_exists){
                        nextTick(() => {
                            router.push({path: `/set-password/${fbuser.accessToken}`, state: response.data})
                        })
                    }else{
                        if(response && (response.data.token.access_token)) {
                            AuthTokenService.setTokens(response.data.token.access_token, response.data.token.refresh_token)
                            if(response.success){
                                AuthTokenService.redirectToDashboardIfLoggedIn()
                            }
                        }
                    }
                } catch(error) {
            console.log('error fb: ', error)
                    validation.storeApiValidation(error)
                    submitLimiter()
                }
            }
            if(!AuthTokenService.getAccessToken()) {
                router.push('/login')
            }
            // Handle successful sign-in
        } catch (error) {
            if (error.message.includes('auth/account-exists-with-different-credential')) {
                confirmer.openSnackBar({type: "error", msg:'You have already signed up with Google. Please try logging in with Google.'});
            }
            submitLimiter()
            // Handle errors
        }

    }

    return {
        signInWithGoogleMethod,
        signInWithFacebookMethod
    }
}

export {useSocialLogin, isGoogleUser, isFacebookUser, isProcessing}
  